import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Footer = () => {
  return (
    <footer className="w-full bg-foreground-900 text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Kakobuy Spreadsheet</h3>
            <p className="text-foreground-200 text-sm leading-relaxed mb-4">
              Największy Kakobuy Spreadsheet w Polsce – tysiące starannie wybranych produktów z codziennie aktualizowanymi linkami.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-5 py-2.5 rounded-lg transition-all duration-300 whitespace-nowrap text-sm"
            >
              <i className="ri-external-link-line"></i>
              Kakobuy Sheet
            </a>
          </div>

          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4 text-foreground-300">
              Kategorie Kakobuy Spreadsheet
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.link}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                >
                  {cat.namePl}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4 text-foreground-300">
              Przydatne Linki
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Strona Główna
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/kakobuy-spreadsheet-poradnik-2026"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Poradnik Kakobuy Spreadsheet 2026
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/nike-kakobuy-spreadsheet-2026"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Nike Kakobuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/jordan-kakobuy-spreadsheet-2026"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Jordan Kakobuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/wysylka-kakobuy-spreadsheet-polska"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Wysyłka do Polski
                </Link>
              </li>
              <li>
                <Link
                  to="/artykul/kakobuy-spreadsheet-vs-inne-porownanie"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Porównanie Arkuszy
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-200 hover:text-primary-400 text-sm transition-colors"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-foreground-400 text-xs">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-primary-400 transition-colors"
            >
              kaspreadsheet.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;